import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/core/api/baseQuery'
import { GenericResponseOData } from '@/core/api/interfaces/GenericResponseOData'
import {
  getEstadoByIdQueryOData,
  getPlanPagoQueryOData,
  getPlanPagoTableQueryOData,
} from '@/modules/ReservasTemp/constants/queriesStringOData'
import { PlanPagos, PlanPagosDetalleTabla } from '@/modules/ReservasTemp/interfaces/PlanPagos'


export const planPagoApi = createApi({
  reducerPath: 'planPagoApi',
  baseQuery,
  endpoints: (builder) => ({
    getPlanPagoTotales: builder.query<GenericResponseOData<PlanPagos>, { reservaCentralizadaId: number }>({
      query: ({ reservaCentralizadaId }) => ({
        url: `/PlanPagos?${getPlanPagoQueryOData.replace('{ID}', reservaCentralizadaId.toString())}`,
        method: 'GET',
      }),
    }),
    getPlanPagoEstado: builder.query<GenericResponseOData<{ EstadoId: number, Nombre: string }[]>, void>({
      query: () => ({
        url: `/Estados?${getEstadoByIdQueryOData}`,
        method: 'GET',
      }),
    }),
    getPlanPagoTable: builder.query<GenericResponseOData<PlanPagosDetalleTabla>, { planPagosId: number }>({
      query: ({ planPagosId }) => ({
        url: `/PlanPagosDetalles?${getPlanPagoTableQueryOData.replace('{ID}', planPagosId.toString())}`,
        method: 'GET',
      }),
    }),
    postPlanPagoTable: builder.mutation<PlanPagosDetalleTabla, PlanPagosDetalleTabla>({
      query: (body) => ({
        url: `/PlanPagosDetalles`,
        method: 'POST',
        body,
      }),
    }),
    putPlanPagoTable: builder.mutation<PlanPagosDetalleTabla, PlanPagosDetalleTabla>({
      query: (body) => ({
        url: `/PlanPagosDetalles(${body.PlanPagosDetalleId})`,
        method: 'PUT',
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetPlanPagoTotalesQuery,
  useLazyGetPlanPagoTableQuery,
  usePostPlanPagoTableMutation,
  usePutPlanPagoTableMutation,
  useLazyGetPlanPagoEstadoQuery,
} = planPagoApi

